import {VehicleIncidentTypeEnum} from '@/services/api-clients';

export function vehicleIncidentTypeIconFilter (type: VehicleIncidentTypeEnum): string {
    switch(type) {
      case VehicleIncidentTypeEnum.Crash: return 'md_taxi_alert';
      case VehicleIncidentTypeEnum.Fee: return 'mdi-police-badge';
      case VehicleIncidentTypeEnum.Maintain: return 'mdi-account-wrench';
      case VehicleIncidentTypeEnum.Failure: return 'mdi-car-off';
      case VehicleIncidentTypeEnum.Other: return 'mdi-help';
      case VehicleIncidentTypeEnum.Convey: return 'mdi-car-arrow-right';
      case VehicleIncidentTypeEnum.Return: return 'mdi-car-arrow-left';
      case VehicleIncidentTypeEnum.TownTransfer: return 'mdi-swap-horizontal';
      case VehicleIncidentTypeEnum.Theft: return 'mdi-circle-off-outline';
      case VehicleIncidentTypeEnum.BackToFleet: return 'mdi-restore';
      case VehicleIncidentTypeEnum.Workshop: return 'mdi-hammer-wrench';
      case VehicleIncidentTypeEnum.ReceiveFromWorkshop: return 'mdi-wrench-check';
      case VehicleIncidentTypeEnum.PeriodicVehicleInspection: return 'mdi-car-clock'
      default: return '';
    }
}
